/* P01yg107 Labs — storefront behaviour (no dependencies) */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function toast(html) {
    var el = document.getElementById('CartToast');
    if (!el) return;
    el.innerHTML = html;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-cart-label]').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }

  // Mobile menu
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    var nav = document.getElementById(t.getAttribute('aria-controls'));
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (nav) nav.classList.toggle('is-open', !open);
  });

  // AJAX add to cart (progressive enhancement: forms still work without JS)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        setCount(cart.item_count);
        toast('Added to cart — <a href="' + root + 'cart">view cart &amp; check out</a>');
      })
      .catch(function (err) { toast(String(err.message || err)); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  // Homepage filter chips
  document.querySelectorAll('[data-filter-group]').forEach(function (group) {
    var grid = document.getElementById(group.getAttribute('data-filter-group'));
    if (!grid) return;
    var empty = grid.parentNode.querySelector('[data-filter-empty]');
    group.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter]');
      if (!chip) return;
      var tag = chip.getAttribute('data-filter');
      group.querySelectorAll('[data-filter]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      var shown = 0;
      grid.querySelectorAll('[data-tags]').forEach(function (card) {
        var tags = ' ' + card.getAttribute('data-tags') + ' ';
        var match = tag === 'all' || tags.indexOf(' ' + tag + ' ') !== -1;
        card.hidden = !match;
        if (match) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
    });
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-thumb]');
    if (!th) return;
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = th.getAttribute('data-src');
    main.srcset = th.getAttribute('data-srcset') || '';
    main.alt = th.getAttribute('data-alt') || '';
    th.parentNode.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === th ? 'true' : 'false'); });
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (b.getAttribute('data-qty') === 'up' ? 1 : -1));
  });

  // Variant picker → update hidden id, price and button
  document.querySelectorAll('[data-variant-json]').forEach(function (script) {
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (err) { return; }
    var form = script.closest('form');
    if (!form) return;
    var selects = form.querySelectorAll('[data-option-index]');
    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[type="submit"]');
      var price = document.querySelector('[data-product-price]');
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; } return; }
      idInput.value = v.id;
      if (price) price.textContent = v.price_formatted;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  });
})();
